/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define(['doT',
	'../../../../lib/@waca/core-client/js/core-client/ui/core/View',
	'../../../../lib/@waca/core-client/js/core-client/utils/Deferred',
	'jquery',
	'text!./LayoutIndicator.html'],
function( dot, BaseView, Deferred, $, LayoutIndicatorTemplate) {

	var LayoutIndicator = null;
	LayoutIndicator = BaseView.extend({

		OFFSET: 30,

		init: function(options) {
			LayoutIndicator.inherited('init', this, arguments);
			this.$node = options.node;

		},

		render: function() {
			const template = dot.template(LayoutIndicatorTemplate);
			const layoutIndicatorHtml = template();
			this.$el = $(layoutIndicatorHtml);
			this.$node.prepend(this.$el);
			if(this.$node.is('body')){
				this.containerSize = { 'width':$(window).width(), 'height':$(window).height() };
			}else {
				this.containerSize = { 'width':this.$node.width(), 'height':this.$node.height() };
			}
			this.$content = $(this.$el.find('.layoutDashboardIndicatorText')[0]);
		},

		updatePosition: function(position){
			let offscreenX = 0;
			let offscreenY = 0;
			let offsetX = 0;
			let offsetY = 0;
			const scrollLeft = this.$node.scrollLeft();
			const scrollTop = this.$node.scrollTop();
			const leftPosition = position.left + scrollLeft;
			const topPosition = position.top + scrollTop;

			offscreenX = this.containerSize.width - this.$el.width() - 50;
			offscreenY = this.containerSize.height - this.$el.height();

			if(offscreenX - position.left < 0){
				offsetX = offscreenX - position.left;
			}

			if(offscreenY - position.top < 0){
				offsetY = offscreenY - position.top;
			}

			let finalX = (leftPosition + this.OFFSET) + offsetX;
			finalX = (finalX > scrollLeft) ? finalX + 'px' : scrollLeft + 'px';
			let finalY = (topPosition + this.OFFSET) + offsetY;
			finalY = (finalY > scrollTop) ? finalY + 'px' : scrollTop + 'px';

			this.$el.css({ top: finalY, left: finalX });
		},

		updateContent: function(content){
			this.$content.text(content);
		},

		remove: function(){
			this.$el.remove();
		},

		show: function(){
			this.$el.show();
		},

		hide: function(){
			this.$el.hide();
		}

	});

	return LayoutIndicator;
});
